import React from 'react';
import classNames from 'classnames';
import { Avatar } from '@mui/material';
import { LevelAttributes } from '@loyalty/shared-common/gamification-api-client';
import { getLevelImage } from '@loyalty/editor-components';
import { useTranslation } from 'react-i18next';
import styles from './LevelImage.module.scss';

interface Props {
  level: LevelAttributes;
  style?: Record<string, string>;
  className?: string;
}

export function LevelImage({ level, className }: Props) {
  const { i18n } = useTranslation();
  const levelImage = getLevelImage(level, i18n.language);

  return (
    <Avatar
      src={levelImage}
      alt="level"
      className={classNames(className, styles.level)}
      style={{
        filter: level.deletedAt ? 'grayscale(100%)' : undefined,
        opacity: level.deletedAt ? '0.5' : '1',
      }}
    />
  );
}
